import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t;

import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H1 from 'UIComponents/elements/headings/H1';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import breakpoint from '../../constants/Breakpoints';
import ProductInfoContainer from '../common/ProductInfoContainer';
import EBX642CompareProCard from '../merch-card/Ebx642CompareProCard';
const FlexContainer = styled(UIFlex).withConfig({
  displayName: "CompareProInterstitialOverview__FlexContainer",
  componentId: "yf07sv-0"
})(["z-index:1;padding-top:48px;", ";"], breakpoint.tablet(_t || (_t = _`
  padding-right: 48px;
  padding-left: 48px;
`)));

const CompareProInterstitialOverview = ({
  upgradeProduct,
  productLevel,
  productLine
}) => {
  return /*#__PURE__*/_jsxs(FlexContainer, {
    direction: 'row',
    align: 'center',
    justify: 'center',
    children: [/*#__PURE__*/_jsx(UIBox, {
      grow: 1,
      basis: "50%",
      className: "p-right-4",
      children: /*#__PURE__*/_jsx(ProductInfoContainer, {
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(H1, {
            className: "m-bottom-10",
            style: {
              fontSize: 55,
              marginRight: 16
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `EBX642.${upgradeProduct}.page.title`
            })
          }), /*#__PURE__*/_jsx("p", {
            className: "text-left",
            style: {
              fontSize: 24
            },
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `EBX642.${upgradeProduct}.page.subtitle`
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(UIBox, {
      children: /*#__PURE__*/_jsx(EBX642CompareProCard, {
        productLevel: productLevel,
        productLine: productLine
      })
    })]
  });
};

export default CompareProInterstitialOverview;